"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mallTemplate = void 0;
var utils_1 = require("../../utils");
var mallCustomGroupsUrl = '/mail-templates/custom/groups';
exports.mallTemplate = function (axios) {
    return {
        // [Mail Template]
        getMailTemplatesCustomGroups: function (getMailTemplatesCustomGroups) {
            return axios.get(mallCustomGroupsUrl, getMailTemplatesCustomGroups);
        },
        postMailTemplatesCustomGroups: function (postMailTemplatesCustomGroups) {
            return axios.post(mallCustomGroupsUrl, postMailTemplatesCustomGroups.data, postMailTemplatesCustomGroups);
        },
        deleteMailTemplatesCustomGroups: function (deleteMailTemplatesCustomGroups) {
            var url = mallCustomGroupsUrl + "/{groupNo}";
            url = utils_1.paramPathchange(url, deleteMailTemplatesCustomGroups);
            return axios.delete(url, deleteMailTemplatesCustomGroups);
        },
        deleteMailTemplatesCustomGroupsTemplates: function (deleteMailTemplatesCustomGroupsTemplates) {
            var url = mallCustomGroupsUrl + "/{groupNo}/templates/{templateNo}";
            url = utils_1.paramPathchange(url, deleteMailTemplatesCustomGroupsTemplates);
            return axios.delete(url, deleteMailTemplatesCustomGroupsTemplates);
        },
        putMailTemplatesCustomGroups: function (putMailTemplatesCustomGroups) {
            var url = mallCustomGroupsUrl + "/{groupNo}";
            url = utils_1.paramPathchange(url, putMailTemplatesCustomGroups);
            return axios.put(url, putMailTemplatesCustomGroups.data, putMailTemplatesCustomGroups);
        },
        putMailTemplatesCustomGroupsOrder: function (putMailTemplatesCustomGroupsOrder) {
            var url = mallCustomGroupsUrl + "/{groupNo}/order";
            url = utils_1.paramPathchange(url, putMailTemplatesCustomGroupsOrder);
            return axios.put(url, putMailTemplatesCustomGroupsOrder.data, putMailTemplatesCustomGroupsOrder);
        },
        putMailTemplatesCustomGroupsTemplates: function (putMailTemplatesCustomGroupsTemplates) {
            var url = mallCustomGroupsUrl + "/{groupNo}/templates/{templateNo}";
            url = utils_1.paramPathchange(url, putMailTemplatesCustomGroupsTemplates);
            return axios.put(url, putMailTemplatesCustomGroupsTemplates.data, putMailTemplatesCustomGroupsTemplates);
        },
        putMailTemplatesCustomGroupsTemplatesOrder: function (putMailTemplatesCustomGroupsTemplatesOrder) {
            var url = mallCustomGroupsUrl + "/{groupNo}/templates/{templateNo}/order";
            url = utils_1.paramPathchange(url, putMailTemplatesCustomGroupsTemplatesOrder);
            return axios.put(url, putMailTemplatesCustomGroupsTemplatesOrder.data, putMailTemplatesCustomGroupsTemplatesOrder);
        },
        postMailTemplatesCustomGroupsTemplates: function (postMailTemplatesCustomGroupsTemplates) {
            var url = mallCustomGroupsUrl + "/{groupNo}/templates";
            url = utils_1.paramPathchange(url, postMailTemplatesCustomGroupsTemplates);
            return axios.post(url, postMailTemplatesCustomGroupsTemplates.data, postMailTemplatesCustomGroupsTemplates);
        },
        //メールテンプレートの発送テスト
        postMailTemplatesAutoTemplatesTest: function (postMailTemplatesAutoTemplatesTest) {
            var url = '/mail-templates/auto/templates/{templateType}/test';
            url = utils_1.paramPathchange(url, postMailTemplatesAutoTemplatesTest);
            return axios.post(url, postMailTemplatesAutoTemplatesTest.data, postMailTemplatesAutoTemplatesTest);
        },
        putMailTemplatesAutoTemplatesReset: function (putMailTemplatesAutoTemplatesReset) {
            var url = '/mail-templates/auto/templates/{templateType}/reset';
            url = utils_1.paramPathchange(url, putMailTemplatesAutoTemplatesReset);
            return axios.put(url, putMailTemplatesAutoTemplatesReset.data, putMailTemplatesAutoTemplatesReset);
        },
        getMailTemplatesAutoTemplatesDefault: function (request) {
            var url = '/mail-templates/auto/templates/{templateType}/default';
            url = utils_1.paramPathchange(url, request);
            return axios.get(url, request);
        },
        // メールテンプレート修正
        putMailTemplatesAutoTemplates: function (putMailTemplatesAutoTemplates) {
            var url = '/mail-templates/auto/templates/{templateType}';
            url = utils_1.paramPathchange(url, putMailTemplatesAutoTemplates);
            return axios.put(url, putMailTemplatesAutoTemplates.data, putMailTemplatesAutoTemplates);
        },
        // メールテンプレート照会
        getMailTemplatesAutoTemplates: function (getMailTemplatesAutoTemplates) {
            var url = '/mail-templates/auto/templates/{templateType}';
            url = utils_1.paramPathchange(url, getMailTemplatesAutoTemplates);
            return axios.get(url, getMailTemplatesAutoTemplates);
        },
        // メールテンプレートグループ照会
        getMailTemplatesAutoGroups: function (getMailTemplatesAutoGroups) {
            return axios.get('/mail-templates/auto/groups', getMailTemplatesAutoGroups);
        }
    };
};
